import React from 'react';
import PropTypes from 'prop-types';

import { SkeletonDetalization } from '../Skeletons';

export const SectionWrapper = ({ isFetching = false, isError = false, children, skeletonName }) => {
  if (isFetching) {
    return <SkeletonDetalization name={skeletonName} />;
  }

  if (isError) {
    return null;
  }

  return <>{children}</>;
};

SectionWrapper.propTypes = {
  isFetching: PropTypes.bool,
  isError: PropTypes.bool,
  skeletonName: PropTypes.string,
};
